import styles from "./Legend.module.css";
import { appConfig } from "../../services/configService";

const Legend = () => {
  const { redColor, amberColor, greenColor } = appConfig;
  return (
    <div style={{ backgroundColor: "white", padding: "0.5rem" }}>
      <h6 className={styles.legendHeader}>Key</h6>
      <ul className={styles.customList}>
        <li className={styles.listItem}>
          <div style={{ backgroundColor: greenColor }} />
          We can connect you
        </li>
        <li className={styles.listItem}>
          <div style={{ backgroundColor: amberColor }} />
          We should be able to connect you
        </li>
        <li className={styles.listItem}>
          <div style={{ backgroundColor: redColor }} />
          We need to investigate further
        </li>
      </ul>
    </div>
  );
};

export default Legend;
